module.exports = __webpack_public_path__ + "static/media/logo.6fef0bdd.png";